













import Vue from "vue";
import Component from "vue-class-component";
import empresaAtualService from '../empresa-atual/empresa-atual-service';
import Api from '../../base/api.typings';
import routerService from '../../base/router-service';

@Component
export default class BotaoTrocarEmpresa extends Vue {
    empresaAtual: string = null;
    created() {
        this.obterEmpresaAtual();
    }

    async selecaoEmpresa() {
        await routerService.goTo('empresa-atual-listar');
        window.location.reload();
    }

    async obterEmpresaAtual() {
        let empresa = await empresaAtualService.obterEmpresaAtual();

        if (!empresa)
            return;

    this.empresaAtual = empresa.nomeFantasia;

    }
}
